import { createSlice } from '@reduxjs/toolkit';

import {
    FETCH_PROJECT,
    FETCH_PROJECT_FAILURE,
    FETCH_PROJECT_SUCCESS,
    RESET_VALUES,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    project: {
        data: {},
        errors: [],
        isFetching: false,
    },
};

const projectSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [FETCH_PROJECT]: (state) => {
            state.project.isFetching = true;
        },
        [FETCH_PROJECT_FAILURE]: (state, action) => {
            state.project = {
                ...state.project,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PROJECT_SUCCESS]: (state, action) => {
            state.project = {
                ...state.project,
                data: action.payload,
                isFetching: false,
            };
        },
        [RESET_VALUES]: () => INITIAL_STATE,
    },
});

export const projectActions = projectSlice.actions;

export default projectSlice.reducer;
